/**
 * Shared helpers for 3PL Billing UI components.
 */
export const fmt$ = (n) => `$${(Number(n) || 0).toFixed(2)}`;
export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString() : '—');
